import { Pipe, PipeTransform } from '@angular/core';
import { IAttachmentDto } from '@common/types';
import { SYSTEM_USER_ID } from '@common/constants';
@Pipe({ name: 'getSystemMaterial' })
export class GetSystemAccountMaterialPipe implements PipeTransform {
  transform(materials: IAttachmentDto[]): IAttachmentDto[] {
    return materials.filter((m) => m.createdBy.id === SYSTEM_USER_ID);
  }
}
